import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';
import ImageDisplay from '../ImageDisplay';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      marginBottom: 12,
    },
    card: props => ({
      flex: '0 0 auto',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: color.$8,
      backgroundSize: 'cover',
      borderRadius: 16,
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      marginBottom: 8,
      '&::after': {
        display: 'block',
        content: '""',
        paddingBottom: props?.message?.data?.elements.every(
          element => element?.imageUrl,
        )
          ? 0
          : '100%',
      },
      '&:not(:first-child)': {
        marginLeft: 8,
      },
    }),
    content: {
      minHeight: 106,
      display: 'flex',
      maxWidth: '100%',
      overflowX: 'auto',
      boxShadow: '0 8px 36px 0 rgb(0 0 0 / 6%)',
    },
  }),
  { name: 'ImageCardPreview' },
);

function ImageCardPreview({ orgIconURL, message }) {
  const classes = useStyles({ message });

  return (
    <div className={classes.root}>
      <ImageDisplay
        style={{ objectFit: 'cover', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <div className={classes.content}>
        {message.data.elements.map((element, index) => {
          const { aspectRatio } = element;
          const btn = element?.buttons[0];
          const isUrl = btn?.type === 'url' && btn?.data;
          let width = '';
          let height = '';

          switch (aspectRatio) {
            case '1:1.618':
              width = '204px';
              height = '330px';
              break;
            case '1.92:1':
              width = '204px';
              height = '106px';
              break;
            case '1:1':
            default:
              width = '204px';
              height = '204px';
              break;
          }

          return (
            <div
              key={`preview-image-card-${index}`}
              className={classes.card}
              style={{
                width,
                height,
                backgroundImage: `url(${element?.imageUrl})`,
                cursor: isUrl ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (isUrl) {
                  window.open(btn.data);
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

ImageCardPreview.propTypes = {
  message: PropTypes.shape({}).isRequired,
};

export default ImageCardPreview;
